import React from 'react';
import { StarIcon } from 'lucide-react';
import { testimonials } from '../data/testimonials';
export function Testimonials() {
  return <section className="bg-white py-5 sm:py-7" data-id="element-179" data-mp="3kqw3yjl330fl">
      <div className="mx-auto max-w-5xl px-4 sm:px-6" data-id="element-180" data-mp="3fze45yusr5w7">
        <h2 className="text-center text-3xl leading-none text-navy sm:text-5xl" data-id="element-181" data-mp="3fxuni758astw">
          WHAT WELDING INSPECTION PROFESSIONALS COULD SAY{' '}
          <span className="text-tech" data-id="element-182" data-mp="36zimdb6qkcn7">ABOUT THIS SYSTEM</span>
        </h2>
        <p className="mt-1 text-center text-xs italic text-steel/80" data-id="element-183" data-mp="36wmpzrajdw0v">
          Illustrative testimonial placeholders only. These are not actual customer reviews.
          Replace with verified testimonials before publishing.
        </p>

        <div className="mt-3 grid gap-2 md:grid-cols-2 md:gap-2.5" data-id="element-184" data-mp="2s2i7i89n8c65">
          {testimonials.map((testimonial, i) => <article key={testimonial.headline} className={`flex flex-col rounded-xl border border-metal/60 bg-ice p-3 shadow-sm sm:p-4 ${i === 0 ? 'border-l-4 border-l-tech md:col-span-2' : ''}`} data-id="element-185" data-mp="v8555k5bgowg" data-mpi={i}>
              <div className="flex gap-0.5" role="img" aria-label="5 out of 5 stars" data-id="element-186" data-mp="m5b5ns9ag0jx">
                {[0, 1, 2, 3, 4].map(star => <StarIcon key={star} className="h-4 w-4 text-gold" fill="currentColor" strokeWidth={0} aria-hidden="true" data-id="element-187" data-mp="79lezgt5qz8v" />)}
              </div>
              <h3 className="mt-1 font-display text-sm font-extrabold normal-case leading-tight tracking-normal text-navy sm:text-base" data-id="element-188" data-mp="14u7omzz8j6mu">
                “{testimonial.headline}”
              </h3>
              <p className="mt-1 text-sm leading-snug text-steel" data-id="element-189" data-mp="v4ep4xcdahyy">“{testimonial.quote}”</p>
              <div className="mt-auto flex items-center gap-3 pt-2" data-id="element-190" data-mp="1iu9019d4lwgk">
                <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-navy font-display text-sm font-extrabold text-white" aria-hidden="true" data-id="element-191" data-mp="1nlqqv4lfqgnt">
                  {testimonial.name.charAt(0)}
                </span>
                <div data-id="element-192" data-mp="1ohay4penf3tw">
                  <p className="font-display text-sm font-bold leading-none text-navy" data-id="element-193" data-mp="1ogjca6auskgt">
                    — {testimonial.attribution}
                  </p>
                  <p className="mt-0.5 text-xs text-steel/90" data-id="element-194" data-mp="1jkkfpvfdfw5b">
                    {testimonial.name}, {testimonial.age} · {testimonial.role} ·{' '}
                    {testimonial.location}
                  </p>
                </div>
              </div>
            </article>)}
        </div>
      </div>
    </section>;
}